module.exports = ".row:nth-child(odd){\r\n     background: #ececec;\r\n     padding-top: 10px;\r\n   } \r\n   .row:nth-child(even){     \r\n     padding-top: 10px;\r\n   } \r\n   .row{\r\n     padding:9px 0px 0px !important;\r\n } \r\n   .error-msg{\r\n     margin-top:-4px;\r\n } \r\n   .input-group label{\r\n     width:100%;\r\n } \r\n   .margin-top {\r\n   margin-top: 10px;\r\n } \r\n   .modal-dialog{\r\n   width:800px;\r\n }"


//////////////////
// WEBPACK FOOTER
// ./src/app/Masters/Stations/station-form/station-form.component.css
// module id = ./src/app/Masters/Stations/station-form/station-form.component.css
// module chunks = main